<mat-icon>{{ icon() ?? defaultIcon() }}</mat-icon>

<p>
  <strong>{{ text() }}</strong>
</p>

@if (dismiss.observed) {
  <mat-icon
    class="dismiss-button"
    (click)="dismiss.emit()">
    close
  </mat-icon>
}
